export default "__VITE_ASSET__f6bbe23e__"